import {Skeleton} from '@translated/babele-react'
import clsx from 'clsx'

const HubSpotFormSkeleton = ({isVisible}: {isVisible: boolean}) => {
  return (
    <div className={clsx('flex flex-col gap-7 rounded-sm px-6 py-7', !isVisible && 'hidden')}>
      <div className="flex w-full flex-col gap-7 lg:flex-row lg:gap-6">
        <div className="flex w-full flex-col gap-3">
          <Skeleton isLoading className="h-4 w-[7rem] rounded-xs" />
          <Skeleton isLoading className="h-12 w-full rounded-sm" />
        </div>
        <div className="flex w-full flex-col gap-3">
          <Skeleton isLoading className="h-4 w-[7rem] rounded-xs" />
          <Skeleton isLoading className="h-12 w-full rounded-sm" />
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <Skeleton isLoading className="h-4 w-[7rem] rounded-xs" />
        <Skeleton isLoading className="h-12 w-full rounded-sm" />
      </div>
      <div className="flex flex-col gap-7 lg:flex-row lg:gap-6">
        <div className="flex w-full flex-col gap-3">
          <Skeleton isLoading className="h-4 w-[7rem] rounded-xs" />
          <Skeleton isLoading className="h-12 w-full rounded-sm" />
        </div>
        <div className="flex w-full flex-col gap-3">
          <Skeleton isLoading className="h-4 w-[7rem] rounded-xs" />
          <Skeleton isLoading className="h-12 w-full rounded-sm" />
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <Skeleton isLoading className="h-4 w-[7rem] rounded-xs" />
        <Skeleton isLoading className="h-12 w-full rounded-sm" />
      </div>
      <div className="flex flex-col gap-3">
        <Skeleton isLoading className="h-4 w-[7rem] rounded-xs" />
        <Skeleton isLoading className="h-[6rem] w-full rounded-sm" />
      </div>
      <div className="flex gap-3 pb-2">
        <Skeleton isLoading className="size-6 rounded-xs" />
        <div className="flex w-full flex-col gap-3 pt-1">
          <Skeleton isLoading className="h-3 w-full rounded-sm" />
          <Skeleton isLoading className="h-3 w-1/3 rounded-sm" />
        </div>
      </div>
      <Skeleton isLoading className="h-12 w-full rounded-sm" />
    </div>
  )
}

export default HubSpotFormSkeleton
